<template>
  <div>
    <div class="flex">
      <div class="w-1/3 pr-2">
        <select name="startTimeHour" v-model="timeHour" v-validate="'required'" @change="updateTime" ref="hour">
          <option value="" disabled selected>Hour</option>
          <option v-for="(hour, index) in hours" :key="index">{{ hour | leftPad }}</option>
        </select>
      </div>
      <div class="pr-2 pt-3 font-sans-bold">:</div>
      <div class="w-1/3 pr-2">
        <select name="startTimeMinute" v-model="timeMinute" v-validate="'required'" @change="updateTime">
          <option value="" disabled selected>Minute</option>
          <option v-for="(minute, index) in minutes" :key="index">{{ minute | leftPad }}</option>
        </select>
      </div>
      <div class="w-1/3">
        <select name="startTimeMeridiem" v-model="timeMeridiem" v-validate="'required'" @change="updateTime">
          <option value="" disabled selected>AM or PM</option>
          <option>AM</option>
          <option>PM</option>
        </select>
      </div>
    </div>
    <input type="hidden" v-model="fullTime" :name="name">
  </div>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    name: String,
    value: [String, Object]
  },
  data: () => ({
    timeHour: "",
    timeMinute: "",
    timeMeridiem: "",
    fullTime: ""
  }),
  computed: {
    hours() {
      return _.range(1, 13, 1);
    },
    minutes() {
      return _.range(0, 60, 5);
    }
  },
  watch: {
    value(time) {
      time = time.replace(" ", ":");
      time = time.split(":");

      this.timeHour = time[0];
      this.timeMinute = time[1];
      this.timeMeridiem = time[2];
    }
  },
  methods: {
    focus() {
      this.$refs.hour.focus();
    },
    updateTime() {
      let timeString = `${this.timeHour}:${this.timeMinute} ${this.timeMeridiem}`;

      const timeRegex = /\d{2}:\d{2}\s([AP])M/g;
      const correct = timeString.match(timeRegex);

      if (correct && correct.length > 0) {
        this.fullTime = timeString;
        this.$emit("input", this.fullTime);
      }
    }
  },
  mounted() {}
};
</script>
